import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetNotifications as GetNotificationsQuery} from 'nutshell-graphql-types';

import GET_NOTIFICATIONS from '../queries/get-notifications.graphql';

export const useGetNotifications = () => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
        startPolling,
        stopPolling,
    } = useQuery<GetNotificationsQuery, Record<any, any>>(GET_NOTIFICATIONS, {});

    const notifications = data ? data.notifications : null;

    return {
        notifications: notifications || [],
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
        startPolling,
        stopPolling,
    };
};
